import { Component, inject, Input } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
	ButtonIconComponent,
	IMenu,
	ItemComponent,
	MenuComponent,
} from '@tecalisdev/infinity';
import { downloadJsonAsTxt } from '../../../core/utils/utils';
import { RolePermissionsService } from '../../../core/services/role-permissions.service';
import { MenuItemAction } from '../../../shared/models/master.models';
import { ModalJsonViewerComponent } from '../../../shared/components/modal-json-viewer/modal-json-viewer.component';
import { UserActivityTrackerService } from '../../../shared/services/user-activity-tracker.service';
import { IOperationDetailResponse } from '../../models/operations.models';

@Component({
	selector: 'app-operation-detail-json',
	imports: [TranslatePipe, ItemComponent, ButtonIconComponent, MenuComponent, ModalJsonViewerComponent],
	templateUrl: './operation-detail-json.component.html',
	styleUrl: './operation-detail-json.component.scss',
})
export class OperationDetailJsonComponent {
	@Input() detail: IOperationDetailResponse;

	private userActivityTracker = inject(UserActivityTrackerService);
	private rolePermissions = inject(RolePermissionsService);
	private trans = inject(TranslateService);

	public showModalJsonViewer = false;

	public get dataJsonMenuOpt(): IMenu[] {
		if (!this.rolePermissions.isSuperadmin()) {
			return [];
		}
		return [
			{
				label: this.trans.instant('BUTTON.SEE'),
				icon: 'icon-eye',
				id: MenuItemAction.SHOW,
			},
			{
				label: this.trans.instant('BUTTON.DOWNLOAD'),
				icon: 'icon-download',
				id: MenuItemAction.DOWNLOAD,
			},
		];
	}

	public dataJsonMenuChange(action: IMenu): void {
		if (action.id === MenuItemAction.SHOW) {
			this.showModalJsonViewer = true;
			return;
		}
		if (action.id === MenuItemAction.DOWNLOAD) {
			this.download();
		}
	}

	public download(): void {
		if (!this.detail?.uuid) {
			return;
		}
		downloadJsonAsTxt(`operation-${this.detail.uuid}`, this.detail);

		const reference = this.userActivityTracker.shortReference(this.detail.uuid, 4, 2);
		this.userActivityTracker.track({
			type: 'operations',
			text: `Descarga del json de la operación ${reference}`,
			link: this.userActivityTracker.buildLink(`/operations/detail/${this.detail.uuid}`, reference),
			company_uuid: this.detail?.company_uuid,
		});
	}
}
